<template>
    <footer class="bg-white pt-2">
        <div class="container">
			<div class="row mt-5">
				<!-- about -->
				<!-- FIXME check this class insteal of ps-lg-5 about-text-padding -->
				<div class="col-lg-4 col-12 px-1 ps-lg-5">
					<div class="mb-4 d-flex justify-content-center justify-content-md-start ">
						<router-link to="/">
							<img src="../assets/images/logo-new-dark.svg" class="mb-2" alt="Logo" width="200">
						</router-link>
					</div>
					<div v-if="about.length > 0" class="px-3 px-md-0">
						<p class="about-font d-flex text-center text-md-start text-center" v-html="about.find(c => c.key === 'about' && c.id === 1)?.value"></p>
					</div>
				</div>

				<!-- important links -->
				<div class="col-lg-2 col-md-4 col mb-4 mb-lg-0">
					<h6 class="footer-titles d-flex justify-content-center justify-content-md-start ">{{ $t('footer.important-links') }}</h6>
					<hr>
					<div v-for="item in importantLinks" :key="item.id">
						<div class="mb-2 d-flex justify-content-center justify-content-md-start ">
							<router-link class="footer-items-links" :to="item.to">
								{{ item.name }}
							</router-link>
						</div>
					</div>
				</div>

				<div class="col-auto d-md-none px-0" style="width: 0.8px; background-color: #e5e5e5;"></div>

				<!-- categories -->
				<div class="col-lg-2 col-md-4 col mb-4 mb-lg-0">
					<h6 class="footer-titles d-flex justify-content-center justify-content-md-start ">{{ $t('footer.footer-categories') }}</h6>
					<hr>
					<div v-for="item in [{ id: 2391, name: $t('all-categories') }, ...categories.slice(0, 5)]" :key="item.id">
						<div class="mb-2 d-flex justify-content-center justify-content-md-start ">
							<router-link
								class="footer-items-links"
								:to="
									item.id === 2391
										? { name: 'all-categories', }
										: { name: 'category', params: { slug: item.slug } }
									"
							>
								{{ item.name }}
							</router-link>
						</div>
					</div>
				</div>

				<!-- contact us -->
				<div class="col-lg-4 col-md-4 col-12 contact-us-block mb-4 mb-lg-0 mt-4 mt-md-0">
					<h6 class="footer-titles d-flex justify-content-center justify-content-md-start ">{{ $t('footer.footer-contact-us') }}</h6>
					<hr>
					<div class="d-flex justify-content-center justify-content-md-start mb-3">
						<span class="other-info-content mb-3">
							{{contacts[0]?.address}}
						</span>
					</div>
					<div class="d-flex justify-content-center justify-content-md-start mb-1">
						<a :href="`tel:${contacts[0]?.phone}`" class="other-info-content text-decoration-none dark-blue-color">
							<i class="fa-solid fa-phone mx-1"></i> {{ $t('phone') }} : {{contacts[0]?.phone}}
						</a>
					</div>
					<div class="d-flex justify-content-center justify-content-md-start">
						<a :href="`mailto:${contacts[0]?.email}`" class="other-info-content text-decoration-none dark-blue-color">
							<i class="fa-solid fa-envelope mx-1"></i> {{ $t('email') }} : {{contacts[0]?.email}}
						</a>
					</div>
				</div>
			</div>

			<!-- last element -->
			<hr>
			<div class="w-100 d-flex justify-content-between pb-4">
				<div class="d-flex">
					<span class="copyright-class d-flex align-items-center justify-content-center mt-1">
						Copyright ©2025 All rights reserved
					</span>
					<span class="px-2">|</span>
					<a href="https://www.beetronix.com" target="_blank" class="copyright-class bold d-flex align-items-center justify-content-center mt-1 text-decoration-none dark-blue-color">
						BEETRONIX
					</a>
				</div>
				<div class="d-flex">
					<a :href="contacts[0]?.instagram" class="px-2 social-media-links pointer" target="_blank">
						<i class="fa-brands fa-instagram"></i>
					</a>
					<a :href="contacts[0]?.facebook" class="px-2 social-media-links pointer" target="_blank">
						<i class="fa-brands fa-facebook"></i>
					</a>
				</div>
			</div>
		</div>
    </footer>
</template>

<script>
import { mapState } from 'vuex'
export default {
	name: 'FooterVue',
	data () {
		return {
			importantLinks: [
				{
					id: 1,
					name: this.$t('footer.footer-links.about'),
					to: '/about-us'
				},
				{
					id: 2,
					name: this.$t('footer.footer-links.categories'),
					to: '/all-categories'
				},
				{
					id: 3,
					name: this.$t('footer.footer-links.products'),
					to: '/all-products'

				},
				{
					id: 4,
					name: this.$t('footer.footer-links.contact-us'),
					to: '/contact-us'
				}
			],

			categoriesTest: [
				{
					id: 1,
					name: 'براغي خشب',
					to: '/'
				},
				{
					id: 2,
					name: 'براغي PVS',
					to: '/'
				},
				{
					id: 3,
					name: 'براغي حديد',
					to: '/'
				},
			],

			contactsTest: [
				{
					id: 1,
					name: this.$t('footer.footer-contact-items.location'),
					class: 'mb-3',
					to: '/'
				},
				{
					id: 2,
					name: this.$t('footer.footer-contact-items.phone'),
					class: 'mb-2',
					to: '/'
				},
				{
					id: 3,
					name: this.$t('footer.footer-contact-items.email'),
					class: 'mb-2',
					to: '/'
				}
			]
		}
	},

	computed: {
		...mapState({
			contacts: state => state.contacts.contacts,
			about: state => state.about.about,
			categories: state => state.categories.categories
		})
	}
}
</script>

<style lang="scss" scoped>
.about-font {
	font-size: 13px;
	margin-bottom: 48px;

	@media (max-width: 768px) {
		font-size: 15px;
	}
}

.footer-titles {
	font-size: 14px;
	font-weight: 800;

	@media (max-width: 768px) {
		font-size: 18px;
	}
}

.footer-items-links {
	color: rgb(58, 65, 160);
	text-decoration: none;
	font-size: 13px;

	@media (max-width: 768px) {
		font-size: 15px;
	}
}

.contact-us-block {
	padding-left: 120px;
	@media (max-width: 992px) {
		padding-left: 0;
	}
}

.copyright-class {
	font-size: 12px;
}

.social-media-links {
	color: grey;
	font-size: 18px;
	text-decoration: none;
}

.about-text-padding {
	padding-left: 48px;
	@media (max-width: 992px) {
		padding: 0;
	}
}

.other-info-content {
	font-size: 13px;
	font-weight: 600;
}

// css changes for diffirent translate
html[dir = 'ltr'] 	.about-text-padding {
	padding-right: 48px;
	@media (max-width: 992px) {
		padding: 0;
	}
}

html[dir = 'ltr'] 	.contact-us-block {
	padding-right: 120px;
	padding-left: 0;
	@media (max-width: 992px) {
		padding-right: 0;
	}
}

hr {
	width: 75%;
	@media (max-width: 768px) {
		margin: 14px auto
	}
}

</style>
